<template>
  <div>
    <b-container fluid>
      <div class="line m-1 row">
        <label class="control-label col-sm-4 offset-sm-1 ">Год</label>
        <b-form-select label="Год"
                       :options="detailingYears"
                       :value="selectYearValue"
                       @change.native="changeYear($event)"
                       class="col-sm-3" value-field="id">
        </b-form-select>
      </div>
      <div class="line m-1 row">
        <label class="control-label col-sm-4 offset-sm-1 ">Месяц</label>
        <b-form-select label="Месяц"
                       :options="detailingMonthSelect"
                       v-model="valueMonth"
                       class="col-sm-3" value-field="id"
        >
        </b-form-select>
      </div>
      <div class=" col-sm-6 offset-sm-5 box-footer mt-3">
        <b-button class="b-report" variant="success"
                  @click="getDetailingReport" type="button">Загрузить детализацию
        </b-button>
      </div>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col md="3">
          <b-input-group class="search my-4">
            <b-form-input v-model="filter" placeholder="Поиск"/>
            <i class="nc-icon nc-zoom-split"></i>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        hover
        responsive
        show-empty
        id="mytable"
        :items="items"
        :fields="billingFields"
        :busy.sync="isBusy"
        :no-provider-paging="true"
        :no-provider-sorting="true"
        :no-provider-filtering="true"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        empty-text="Нет данных в таблице"
        empty-filtered-text="Нет данных по вашему запросу"
      >
        <template v-slot:ceil(pid)="data">
          <p>{{data.item.pid}}</p>
          <b-badge variant="info">{{data.item.server_name}}</b-badge>
        </template>
        <template v-slot:table-busy class="text-center text-secondary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загружаем данные...</strong>
        </template>
      </b-table>
      <div class="main-footer">
        <b-form inline>
          <label class="mr-3">Показать</label>
          <b-form-select :options="pageOptions" v-model="perPage"/>
        </b-form>
        <b-pagination align="center"
                      prev-text="&lt;"
                      first-text="&lt;&lt;"
                      next-text="&gt;"
                      last-text="&gt;&gt;"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-6"/>
      </div>
    </b-container>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'detailing',
  data () {
    return {
      billingFields: [
        {
          key: 'pid',
          label: '№ пакета'
        },
        {
          key: 'ptype',
          label: 'Тип пакета'
        },
        {
          key: 'org_name',
          label: 'Организация'
        },
        {
          key: 'user_name',
          label: 'Сотрудник'
        },
        {
          key: 'subgroup',
          label: 'Отдел'
        },
        {
          key: 'transport',
          label: 'Транспорт'
        },
        {
          key: 'date_create',
          label: 'Дата создания'
        },
        {
          key: 'date_modify',
          label: 'Дата модификации'
        },
        {
          key: 'fcs_regnum',
          label: 'Рег. номер'
        },
        {
          key: 'pinfo',
          label: 'Примечание'
        },
        {
          key: 'status',
          label: 'Текущий статус'
        }
      ],
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  mounted () {
    this.getDropdown()
  },
  watch: {
    billingData () {
      this.items = this.billingData
      this.totalRows = this.items.length
    }
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    changeYear (selected) {
      this.updateBillingYear(selected)
    },
    ...mapActions('detailing',
      [
        'getDropdown',
        'getDetailingReport'
      ]
    ),
    ...mapMutations('billing',
      [
        'updateBillingYear',
        'updateBillingMonth'
      ]
    )
  },
  computed: {
    ...mapGetters('detailing',
      [
        'detailingMonthSelect'
      ]
    ),
    ...mapState(
      {
        detailingYears: state => state.detailing.detailingYears,
        selectYearValue: state => state.detailing.selectYearValue,
        selectMonthValue: state => state.detailing.selectMonthValue,
        billingData: state => state.detailing.billingData,
        isBusy: state => state.detailing.isBusy
      }
    ),
    valueMonth: {
      get () {
        return this.selectMonthValue
      },
      set (value) {
        this.$store.commit('detailing/updateBillingMonth', value)
      }
    }
  }
}
</script>

<style scoped>
  .table-responsive {
    overflow: auto;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
  }

  .user-button {
    display: flex;
    justify-content: flex-start;
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .table {
    margin-bottom: 0;
  }

  #mytable {
    width: 100%;
    table-layout: fixed;
  }

  .wrap {
    display: flex;
    justify-content: flex-end;
  }

  table.b-table > thead > tr > th.sorting::after, table.b-table > tfoot > tr > th.sorting::after {
    right: 0.75em;
  }

  ul.rights {
    padding: 0;
  }

  .input-group > .form-control:not(:last-child), .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;

  }

  .input-group i {

    right: 0px;
    position: absolute;
    pointer-events: none;
    padding: 10px;
    z-index: 99;
    color: #9ba3a7;
  }

  .card {
    border: none;
  }

  .control-label {
    text-align: right;
    margin-right: 20px;
    font-size: 14px;
  }

  .line {
    align-items: center;
  }
</style>
